import { render, staticRenderFns } from "./noBmViewPage.vue?vue&type=template&id=679d49b2"
import script from "./noBmViewPage.vue?vue&type=script&lang=js"
export * from "./noBmViewPage.vue?vue&type=script&lang=js"
import style0 from "./noBmViewPage.vue?vue&type=style&index=0&id=679d49b2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports